import { render, staticRenderFns } from "./DataPercentage.vue?vue&type=template&id=2ed97f30&scoped=true"
import script from "./DataPercentage.vue?vue&type=script&lang=js"
export * from "./DataPercentage.vue?vue&type=script&lang=js"
import style0 from "./DataPercentage.vue?vue&type=style&index=0&id=2ed97f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed97f30",
  null
  
)

export default component.exports